
export const submenuToggle = () => {


  const toggles = document.querySelectorAll('.submenu-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const parent = this.parentNode;
      const submenu = parent.querySelector('ul');

      if (parent.classList.contains('is-active')) {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        setTimeout(function () {
          submenu.style.maxHeight = '0';
        }, 0);
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      }
      parent.classList.toggle('is-active');
    });
  });

  // const toggles = document.querySelectorAll('.submenu-toggle');
  // toggles.forEach(toggle => {
  //   toggle.addEventListener('click', function () {
  //     console.log('clicked');

  //     const parent = this.parentNode;
  //     parent.classList.toggle('is-active');
  //   });
  // });
}